function navigation(slider) {
  function updateClasses() {
    var slide = slider.track.details.rel;
    var arrowLeft = document.querySelector(".product-slider .arrow--left");
    var arrowRight = document.querySelector(".product-slider .arrow--right");
    if (!arrowLeft || !arrowRight) return;

    slide === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled");
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled");

    dots.forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active");
    });
  }

  function handlePrev() {
    slider.prev();
  }

  function handleNext() {
    slider.next();
  }

  var arrowLeft = document.querySelector(".product-slider .arrow--left");
  var arrowRight = document.querySelector(".product-slider .arrow--right");
  if (!arrowLeft || !arrowRight) return;

  arrowLeft.addEventListener("click", handlePrev);
  arrowRight.addEventListener("click", handleNext);

  slider.on("created", () => {
    updateClasses();
  });

  slider.on("slideChanged", () => {
    updateClasses();
  });

  var dots = document.querySelectorAll(".product-slider .dot");
  dots.forEach(function (dot, idx) {
    dot.addEventListener("click", () => slider.moveToIdx(idx));
  });
}
function upsellNavigation(slider) {
  function updateClasses() {
    var slide = slider.track.details.rel;
    var arrowLeft = document.querySelector(".upsell-popup .arrow--left");
    var arrowRight = document.querySelector(".upsell-popup .arrow--right");
    if (!arrowLeft || !arrowRight) return;

    slide === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled");
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled");

    dots.forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active");
    });
  }

  function handlePrev() {
    slider.prev();
  }

  function handleNext() {
    slider.next();
  }

  var arrowLeft = document.querySelector(".upsell-popup .arrow--left");
  var arrowRight = document.querySelector(".upsell-popup .arrow--right");
  if (!arrowLeft || !arrowRight) return;

  arrowLeft.addEventListener("click", handlePrev);
  arrowRight.addEventListener("click", handleNext);

  slider.on("created", () => {
    updateClasses();
  });

  slider.on("slideChanged", () => {
    updateClasses();
  });

  var dots = document.querySelectorAll(".upsell-popup .dot");
  dots.forEach(function (dot, idx) {
    dot.addEventListener("click", () => slider.moveToIdx(idx));
  });
}

var mainSlider = document.getElementById("my-keen-slider");
if (mainSlider) {
  var slider = new KeenSlider(mainSlider, {}, [navigation]);
}

var upsellSliderElement = document.getElementById("upsell-slider");
if (upsellSliderElement) {
  let upsellSlider = new KeenSlider(upsellSliderElement, {}, [upsellNavigation]);
}
